<template>
    <div>
        <v-sheet rounded class="v-sheet--offset d-flex align-center justify-center data-loading" elevation="5" :height="isMobile ? 60 : 80" :width="isMobile ? 130 : 250">
            <v-progress-circular indeterminate color="primary" />
        </v-sheet>
    </div>
</template>

<script>
export default {
    name: 'OneDataCardPlusLoad'

}
</script>

<style>

</style>